const images = {
  state: () => ({
    images: [
      {
        id: 1,
        url: "converse.png",
        source: "https://codepen.io/rogerio-romao/pen/RwPaaRR",
        live: "https://codepen.io/rogerio-romao/full/RwPaaRR"
      },
      {
        id: 2,
        url: "todov3.png",
        source: "https://codepen.io/rogerio-romao/pen/KKpzXeG",
        live: "https://codepen.io/rogerio-romao/full/KKpzXeG"
      },
      {
        id: 3,
        url: "markdown-preview.png",
        source: "https://codepen.io/rogerio-romao/pen/dyoXWNb",
        live: "https://codepen.io/rogerio-romao/full/dyoXWNb"
      },
      {
        id: 4,
        url: "rock-paper-scissors.png",
        source: "https://codepen.io/rogerio-romao/pen/jObOzRN",
        live: "https://codepen.io/rogerio-romao/pen/jObOzRN"
      },
      {
        id: 5,
        url: "pomodoro.png",
        source: "https://codepen.io/rogerio-romao/pen/rNVPBJv",
        live: "https://codepen.io/rogerio-romao/pen/rNVPBJv"
      },
      {
        id: 6,
        url: "guess-number.png",
        source: "https://codepen.io/rogerio-romao/pen/XWbQbbN",
        live: "https://codepen.io/rogerio-romao/pen/XWbQbbN"
      },
      {
        id: 7,
        url: "collatz.png",
        source: "https://codepen.io/rogerio-romao/pen/WNQxaWq",
        live: "https://codepen.io/rogerio-romao/full/WNQxaWq"
      },
      {
        id: 8,
        url: "spiral.png",
        source: "https://codepen.io/rogerio-romao/pen/mdevOwm",
        live: "https://codepen.io/rogerio-romao/full/mdevOwm"
      },
      {
        id: 9,
        url: "gol.png",
        source: "https://codepen.io/rogerio-romao/pen/VwvbdZE",
        live: "https://codepen.io/rogerio-romao/full/VwvbdZE"
      },
      {
        id: 10,
        url: "randomizer.png",
        source: "https://codepen.io/rogerio-romao/pen/Baoqvmm",
        live: "https://codepen.io/rogerio-romao/full/Baoqvmm"
      },
      {
        id: 11,
        url: "music-player.png",
        source: "https://codepen.io/rogerio-romao/pen/vYNvBzd",
        live: "https://codepen.io/rogerio-romao/full/vYNvBzd"
      },
      {
        id: 12,
        url: "password-gen.png",
        source: "https://codepen.io/rogerio-romao/pen/poyoWKw",
        live: "https://codepen.io/rogerio-romao/full/poyoWKw"
      },
      {
        id: 13,
        url: "portfolio.png",
        source: "https://github.com/rogerio-romao/rogerio",
        live: "#"
      },
      {
        id: 14,
        url: "catstagram.png",
        source: "https://github.com/rogerio-romao/purple-test",
        live: "https://app.netlify.com/sites/nifty-ptolemy-7b0487"
      },
      {
        id: 15,
        url: "music-database.png",
        source: "https://github.com/rogerio-romao/music-database",
        live: "https://gracious-albattani-2e9b26.netlify.app/"
      },
      {
        id: 16,
        url: "coffee-shop.png",
        source: "https://github.com/rogerio-romao/gatsby-coffee-project",
        live: "https://elated-wing-b66940.netlify.app/"
      },
      {
        id: 17,
        url: "chat.png",
        source: "https://github.com/rogerio-romao/react-chat-app",
        live: "https://react-chat-app-fca7d.web.app/"
      },
      {
        id: 18,
        url: "netflix-clone.png",
        source: "https://github.com/rogerio-romao/netflix-clone-react",
        live: "https://netflix-clone-f2569.web.app/"
      },
      {
        id: 19,
        url: "idle-dj.png",
        source: "https://github.com/rogerio-romao/idle_dj",
        live: "https://silly-lamport-fbfed0.netlify.app/"
      }
    ]
  })
};

export default images;
